import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function ExtractsIcon({ className }: IconProps) {
  return (
    <svg
      width="73"
      height="90"
      viewBox="0 0 73 90"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2780)">
        <path
          d="M3.24565 90H69.7544C71.5395 90 73 88.5268 73 86.7263V13.2313C66.671 6.84753 66.2112 6.38375 59.8822 0H3.24565C1.46054 0 0 1.47317 0 3.27372V86.7263C0 88.5268 1.46054 90 3.24565 90Z"
          fill="#EAEDF8"
        />
        <path
          d="M9.73697 80.5881C8.38462 80.5881 7.30273 79.4969 7.30273 78.1328V24.1438C7.30273 22.7797 8.38462 21.6885 9.73697 21.6885H63.2631C64.6154 21.6885 65.6973 22.7797 65.6973 24.1438V78.1328C65.6973 79.4969 64.6154 80.5881 63.2631 80.5881H9.73697ZM9.73697 23.3253C9.30422 23.3253 8.92556 23.68 8.92556 24.1438V78.1328C8.92556 78.5693 9.30422 78.9513 9.73697 78.9513H63.2631C63.7229 78.9513 64.0745 78.5966 64.0745 78.1328V24.1438C64.0745 23.7073 63.7229 23.3253 63.2631 23.3253H9.73697Z"
          fill="#00C4B3"
        />
        <path
          d="M30.4276 80.5881C30.8874 80.5881 31.239 80.2335 31.239 79.7697V22.5069C31.239 22.0431 30.8874 21.6885 30.4276 21.6885C29.9678 21.6885 29.6162 22.0431 29.6162 22.5069V79.7697C29.6162 80.2335 29.9678 80.5881 30.4276 80.5881Z"
          fill="#00C4B3"
        />
        <path
          d="M8.11415 31.5094H64.8859C65.3457 31.5094 65.6973 31.1548 65.6973 30.691C65.6973 30.2272 65.3457 29.8726 64.8859 29.8726H8.11415C7.65435 29.8726 7.30273 30.2272 7.30273 30.691C7.30273 31.1548 7.65435 31.5094 8.11415 31.5094Z"
          fill="#00C4B3"
        />
        <path
          d="M27.1825 17.1872H50.7134C51.1462 17.1872 51.5249 16.8325 51.5249 16.3687C51.5249 15.9049 51.1732 15.5503 50.7134 15.5503H27.1825C26.7227 15.5503 26.3711 15.9049 26.3711 16.3687C26.3711 16.8325 26.7227 17.1872 27.1825 17.1872Z"
          fill="#00416B"
        />
        <path
          d="M8.11415 17.1872H21.9081C22.3679 17.1872 22.7196 16.8325 22.7196 16.3687C22.7196 15.9049 22.3679 15.5503 21.9081 15.5503H8.11415C7.65435 15.5503 7.30273 15.9049 7.30273 16.3687C7.30273 16.8325 7.65435 17.1872 8.11415 17.1872Z"
          fill="#00416B"
        />
        <path
          d="M8.11415 11.049H23.531C23.9637 11.049 24.3424 10.6943 24.3424 10.2305C24.3424 9.76676 23.9908 9.41211 23.531 9.41211H8.11415C7.65435 9.41211 7.30273 9.76676 7.30273 10.2305C7.30273 10.6943 7.65435 11.049 8.11415 11.049Z"
          fill="#00416B"
        />
        <path
          d="M8.11415 43.7589H64.8859C65.3457 43.7589 65.6973 43.4043 65.6973 42.9405C65.6973 42.4767 65.3457 42.1221 64.8859 42.1221H8.11415C7.65435 42.1221 7.30273 42.4767 7.30273 42.9405C7.30273 43.4043 7.65435 43.7589 8.11415 43.7589Z"
          fill="#00C4B3"
        />
        <path
          d="M8.11415 56.0353H64.8859C65.3457 56.0353 65.6973 55.6806 65.6973 55.2169C65.6973 54.7531 65.3457 54.3984 64.8859 54.3984H8.11415C7.65435 54.3984 7.30273 54.7531 7.30273 55.2169C7.30273 55.6806 7.65435 56.0353 8.11415 56.0353Z"
          fill="#00C4B3"
        />
        <path
          d="M8.11415 68.3117H64.8859C65.3457 68.3117 65.6973 67.957 65.6973 67.4932C65.6973 67.0295 65.3457 66.6748 64.8859 66.6748H8.11415C7.65435 66.6748 7.30273 67.0295 7.30273 67.4932C7.30273 67.957 7.65435 68.3117 8.11415 68.3117Z"
          fill="#00C4B3"
        />
        <path
          d="M59.8825 0L73.0003 13.2313H61.884C60.7751 13.2313 59.8555 12.331 59.8555 11.1852V0H59.8825Z"
          fill="#00416B"
        />
        <path
          d="M12.036 27.3082H25.83C26.2898 27.3082 26.6414 26.9536 26.6414 26.4898C26.6414 26.026 26.2898 25.6714 25.83 25.6714H12.036C11.5762 25.6714 11.2246 26.026 11.2246 26.4898C11.2246 26.9536 11.5762 27.3082 12.036 27.3082Z"
          fill="#00416B"
        />
        <path
          d="M12.036 35.7379H25.83C26.2898 35.7379 26.6414 35.3833 26.6414 34.9195C26.6414 34.4557 26.2898 34.1011 25.83 34.1011H12.036C11.5762 34.1011 11.2246 34.4557 11.2246 34.9195C11.2246 35.3833 11.5762 35.7379 12.036 35.7379Z"
          fill="#00416B"
        />
        <path
          d="M12.036 39.5299H25.83C26.2898 39.5299 26.6414 39.1753 26.6414 38.7115C26.6414 38.2477 26.2898 37.8931 25.83 37.8931H12.036C11.5762 37.8931 11.2246 38.2477 11.2246 38.7115C11.2246 39.1753 11.5762 39.5299 12.036 39.5299Z"
          fill="#00416B"
        />
        <path
          d="M34.8095 27.3082H48.6035C49.0633 27.3082 49.4149 26.9536 49.4149 26.4898C49.4149 26.026 49.0633 25.6714 48.6035 25.6714H34.8095C34.3497 25.6714 33.998 26.026 33.998 26.4898C33.998 26.9536 34.3497 27.3082 34.8095 27.3082Z"
          fill="#00416B"
        />
        <path
          d="M34.8095 37.6476H58.3404C58.7731 37.6476 59.1518 37.2929 59.1518 36.8292C59.1518 36.3654 58.8002 36.0107 58.3404 36.0107H34.8095C34.3497 36.0107 33.998 36.3654 33.998 36.8292C33.998 37.2929 34.3497 37.6476 34.8095 37.6476Z"
          fill="#00416B"
        />
        <path
          d="M12.036 72.7038H25.83C26.2898 72.7038 26.6414 72.3491 26.6414 71.8853C26.6414 71.4216 26.2898 71.0669 25.83 71.0669H12.036C11.5762 71.0669 11.2246 71.4216 11.2246 71.8853C11.2246 72.3491 11.5762 72.7038 12.036 72.7038Z"
          fill="#00416B"
        />
        <path
          d="M12.036 76.4957H25.83C26.2898 76.4957 26.6414 76.1411 26.6414 75.6773C26.6414 75.2135 26.2898 74.8589 25.83 74.8589H12.036C11.5762 74.8589 11.2246 75.2135 11.2246 75.6773C11.2246 76.1411 11.5762 76.4957 12.036 76.4957Z"
          fill="#00416B"
        />
        <path
          d="M34.8095 74.5861H58.3404C58.7731 74.5861 59.1518 74.2314 59.1518 73.7677C59.1518 73.3039 58.8002 72.9492 58.3404 72.9492H34.8095C34.3497 72.9492 33.998 73.3039 33.998 73.7677C33.998 74.2314 34.3497 74.5861 34.8095 74.5861Z"
          fill="#00416B"
        />
        <path
          d="M34.8095 62.1735H58.3404C58.7731 62.1735 59.1518 61.8188 59.1518 61.355C59.1518 60.8913 58.8002 60.5366 58.3404 60.5366H34.8095C34.3497 60.5366 33.998 60.8913 33.998 61.355C33.998 61.8188 34.3497 62.1735 34.8095 62.1735Z"
          fill="#00416B"
        />
        <path
          d="M12.036 49.8971H25.83C26.2898 49.8971 26.6414 49.5425 26.6414 49.0787C26.6414 48.6149 26.2898 48.2603 25.83 48.2603H12.036C11.5762 48.2603 11.2246 48.6149 11.2246 49.0787C11.2246 49.5425 11.5762 49.8971 12.036 49.8971Z"
          fill="#00416B"
        />
        <path
          d="M12.036 62.1735H25.83C26.2898 62.1735 26.6414 61.8188 26.6414 61.355C26.6414 60.8913 26.2898 60.5366 25.83 60.5366H12.036C11.5762 60.5366 11.2246 60.8913 11.2246 61.355C11.2246 61.8188 11.5762 62.1735 12.036 62.1735Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_2780">
          <rect width="73" height="90" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
